import React, { useCallback } from 'react';
import { Typography } from 'antd';

import ContextBar from '../components/common/ContextBar';
import RecentlyDeleted from '../components/history/RecentlyDeleted';
import { fetchMyRecentlyDeleted } from '../services/history';
import { COLLECTIONS_CRUMB } from '../utils/breadcrumbs';

const { Paragraph } = Typography;

/**
 * /collections/deleted — the deleted collections YOU owned or managed, with
 * Restore (delete audit F5; KPR-1267, owner ruling m05). A deleted collection
 * cannot be opened, so its own History tab — where the undo lived — was out
 * of reach: a mis-click needed an engineer. Its owner and its managers may
 * delete a collection and restore it, so this list is theirs, whoever deleted
 * it; a collection's cards, element sets and items are in
 * its own Settings › Recently deleted, and an admin has Admin → Recently
 * deleted. Reached from the Collections page's ⋯.
 */
export default function RecentlyDeletedCollections() {
	const fetchPage = useCallback(paging => fetchMyRecentlyDeleted(paging), []);
	return (
		<>
			<ContextBar breadcrumb={[COLLECTIONS_CRUMB]} title='Recently deleted' />
			<div className='m-1'>
				<Paragraph type='secondary'>
					Deleted collections you own or manage. Restoring one brings it back with its items, cards and sharing.
				</Paragraph>
				<RecentlyDeleted
					fetchPage={fetchPage}
					emptyText='No deleted collections you own or manage.'
				/>
			</div>
		</>
	);
}
